import AccountActions from "~/Settings/AccountSettings/AccountActions"

export default AccountActions
